import React from 'react'
import maxmind from './src/maxmind'
import OmacroWrapper from './src/components/omacro'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './src/styles/global.scss'

export const onInitialClientRender = () =>  maxmind()

export const wrapPageElement = ({ element, props }) => {
    return <OmacroWrapper {...props}>{element}</OmacroWrapper>
}

export const onPreRouteUpdate = ({ location, prevLocation }) => {
    const detail = { location, prevLocation }
    const event = new CustomEvent('PRE_ROUTE_UPDATE', { detail })
    window.dispatchEvent(event)
}

export const onRouteUpdate = ({ location }) => {
    window.dispatchEvent(new Event('navigate'))
    
    const { hash } = location
    if(!hash) return

    const searchedFor = hash.includes('builder-')
    const selector = searchedFor ? `[builder-id="${hash.replace('#', '')}"]` : hash
    const el = document.querySelector(selector)
    
    if(!el) return
    if(searchedFor) el.style.background = '#fff3cd'
    
    const rect = el.getBoundingClientRect()
    const top = rect.top + window.pageYOffset
    const middle = top - (window.innerHeight / 2)

    window.requestAnimationFrame(() => window.scrollTo({
        top: middle,
        left: 0,
        behavior: 'smooth'
    }))
}

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition, }) => {
    const savedScrollPosition = getSavedScrollPosition(location)
    window.requestAnimationFrame(() => window.scrollTo(...savedScrollPosition))
    return false
}
